/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Modal_Create_DescriptionInputs */

const es_feedback_modal_create_description = /** @type {(inputs: Feedback_Modal_Create_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparte un problema o sugerencia.`)
};

const en_feedback_modal_create_description = /** @type {(inputs: Feedback_Modal_Create_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share a problem or suggestion.`)
};

/**
* | output |
* | --- |
* | "Share a problem or suggestion." |
*
* @param {Feedback_Modal_Create_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_modal_create_description = /** @type {((inputs?: Feedback_Modal_Create_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Modal_Create_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_modal_create_description(inputs)
	return en_feedback_modal_create_description(inputs)
});
export { feedback_modal_create_description as "feedback.modal.create_description" }